export const desktopColumnTitles = [
  'time',
  'creator',
  'event',
  'message',
  'reply',
]

export const mobileColumnTitles = ['time', 'event', 'reply']
